import { render, staticRenderFns } from "./simplifyContractFee.vue?vue&type=template&id=f1763a06&scoped=true"
import script from "./simplifyContractFee.vue?vue&type=script&lang=js"
export * from "./simplifyContractFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyContractFee.vue?vue&type=style&index=0&id=f1763a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1763a06",
  null
  
)

export default component.exports